/**
 * SectionHeader.tsx
 * Shared title + one-line description header for every enhanced Activation
 * Funnel section (and the retained Heatstrip/Cascade card), so the full page
 * reads as one cohesive dashboard.
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import { FONT, FONT_H } from './funnelBands';

interface SectionHeaderProps {
  num?: number;
  title: string;
  description: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ num, title, description }) => (
  <Box sx={{ mt: 4, mb: 1.5 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 0.5 }}>
      {num !== undefined && (
        <Box sx={{
          fontFamily: FONT, fontWeight: 700, fontSize: '12px', color: '#fff',
          bgcolor: '#1A5F7A', width: 26, height: 26, borderRadius: '7px',
          display: 'grid', placeItems: 'center', flexShrink: 0,
        }}>
          {num}
        </Box>
      )}
      <Typography component="h2" sx={{ fontFamily: FONT_H, fontSize: '19px', fontWeight: 700, color: '#1A5F7A', lineHeight: 1.15 }}>
        {title}
      </Typography>
    </Box>
    <Typography sx={{ fontFamily: FONT, fontSize: '12.5px', color: '#5D6D7E', maxWidth: 760, lineHeight: 1.5 }}>
      {description}
    </Typography>
  </Box>
);

export default SectionHeader;
